import { ActivityPanel as Panel, type ActivityPanelProps } from '@genieartinc/studio-ui'
import { useTrainingWidgetStore } from '@/stores/useTrainingWidgetStore'
export type { ActivityItem, ActivityStatus, ActivityPanelProps } from '@genieartinc/studio-ui'
export function ActivityPanel(props: ActivityPanelProps) {
  const trainingWidget = useTrainingWidgetStore()
  return <Panel {...props} trainingWidget={trainingWidget} />
}
